export function formatDate(date: Date | string | number, fmt: string) {
  if (!(date instanceof Date)) {
    date = new Date(Number(date));
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export function timeToDate(time: number) {
  const items = [24, 60, 60, 1000, 1];
  let fullTime = time;
  const res: number[] = [];
  let i = 0;
  while (i < 5) {
    const item = items.reduce((a, b) => a * b);
    items.shift();
    const current = Math.floor(fullTime / item);
    fullTime -= current * item;
    res.push(current);
    i++;
  }
  const [day, hour, minute, second, millisecond] = res;
  return {
    day,
    hour,
    minute,
    millisecond,
    second,
  };
}
